<template>
  <a
    v-ripple
    :data-event-id="source.eventId"
    :href="
      eventId == source.eventId ? null : '/main/dashboard/' + source.eventId
    "
    class="eventItem"
    :class="classes"
    @click.prevent="goToEvent()"
  >
    <event-item-img :id="source.eventId" />
    <span v-if="!hideDuration" class="eventItem_duration">
      {{ source.duration }}
    </span>
    <div class="eventItem_detail">
      <div class="eventItem_time">
        <span class="eventItem_date">{{ source.eventNotifyDate | time }}</span>
        <span class="eventItem_hour">{{
          source.eventNotifyDate | time('hour')
        }}</span>
        <span
          v-ripple
          class="eventItem_chevron icon icon-chevron-down"
          @click="handleToggleDetail"
        />
      </div>
      <div class="eventItem_name">
        {{ cameraById[source.cameraId].name }}
      </div>
      <div class="eventItem_types">
        <template v-for="(metaData, i) in source.eventMetaDatas">
          <event-label
            v-if="metaData.key === 'content'"
            :key="source.eventId + '-' + metaData.key + '-' + i"
            :label="metaData.value"
          />
        </template>
      </div>
    </div>
    <div v-if="detailOpen" class="eventItem_btns">
      <v-btn
        class="eventItem_btn"
        :loading="trimLoading"
        :disabled="undefinedCamera(source.cameraId)"
        @click="handleTrim"
      >
        <span class="icon icon-cut" />ビデオクリップ</v-btn
      >
      <v-btn v-if="false" color="warning" class="eventItem_btn"
        ><span class="icon icon-campaign" />SECOMへ通報</v-btn
      >
    </div>
  </a>
</template>

<script>
import EventService from '@/services/event.service';
import { mapState } from 'vuex';
import EventBus from '@/utils/eventBus';
import { EventBusEvents } from '@/globals/enums';
import EventItemImg from './ImageItem.vue';

export default {
  name: 'EventItem',
  components: { EventItemImg },
  props: {
    index: {
      // index of current item
      type: Number,
      default: 0,
    },
    source: {
      type: Object,
      default() {
        return {};
      },
    },
    hideLink: {
      type: Boolean,
      default: false,
    },
    hideDuration: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    eventService: new EventService(),
    detailOpen: false,
    imageError: false,
    trimLoading: false,
  }),
  computed: {
    ...mapState({
      currentEvent: (state) => state.event.event,
      activeEvents: (state) => state.home.activeEvents,
      cameraById: (state) => state.common.cameraById,
    }),
    eventId() {
      return this.currentEvent ? this.currentEvent.eventId : null;
    },
    classes() {
      const isActive = this.activeEvents.some(
        (event) =>
          +event.eventId === +this.source?.eventId &&
          +event.eventId === +this.eventId
      );
      return {
        'eventItem-selected': this.hideLink,
        eventItem_active: isActive,
        eventItem_suspect: isActive,
      };
    },
  },
  mounted() {
    EventBus.on(EventBusEvents.TrimEventComplete, this.handleTrimEventComplete);
  },
  beforeDestroy() {
    EventBus.off(
      EventBusEvents.TrimEventComplete,
      this.handleTrimEventComplete
    );
  },
  methods: {
    handleTrim(e) {
      e.preventDefault();
      e.stopPropagation();
      this.trimLoading = true;
      EventBus.emit(EventBusEvents.TrimEvent, this.source);
    },
    handleToggleDetail(e) {
      e.stopPropagation();
      e.preventDefault();
      this.detailOpen = !this.detailOpen;
    },
    async goToEvent() {
      await this.$store.dispatch('event/changeEvent', this.source);
      EventBus.emit(EventBusEvents.DisplayEvent, this.source);
    },
    handleTrimEventComplete() {
      this.trimLoading = false;
    },
    undefinedCamera(cameraId) {
      return !this.cameraById[cameraId]?.name;
    },
  },
};
</script>

<style lang="scss">
.eventItem {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  padding: 9px 5px 10px 10px;
  border-top: 1px solid #ccc;
  cursor: pointer;
  &_suspect {
    img.imageItem_img {
      border: solid 3px #fcc800;
    }
    .noThumbnailImage {
      border: solid 3px #fcc800;
    }
    .eventItem_duration {
      background-color: #fcc800;
      color: #4b4b4b;
    }
  }
  &_name {
    font-size: 12px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.17;
    letter-spacing: normal;
    text-align: left;
    color: #4b4b4b;
    margin-bottom: 7px;
  }
  &_active {
    background-color: #f3f3f3;
  }
  &_duration {
    position: absolute;
    left: 69px;
    top: 58px;
    height: 17px;
    padding: 0 5px;
    background-color: #4b4b4b;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: right;
    color: #fff;
    padding: 0 5px;
  }
  &_play {
    position: absolute;
    font-size: 50px;
    left: 40px;
    top: 16px;
    border-radius: 10px;
    box-shadow: 0 3px 12px 0 rgba(0, 0, 0, 0.06);
    color: #ffffff;
  }
  &-selected {
    &.homeEvents_event {
      cursor: default;
    }
  }
  &_detail {
    flex: 1;
  }
  &_time {
    display: flex;
    flex: 1;
    color: var(--text-color);
    padding-right: 5px;
  }
  &_date {
    font-size: 12px;
    font-weight: 600;
    margin-right: 6px;
  }
  &_hour {
    font-size: 12px;
    font-weight: 600;
    flex: 1;
  }
  &_chevron {
    font-size: 12px;
    line-height: 18px;
    color: #c1c1c1;
  }
  &_types {
    display: flex;
    flex-direction: column;
    margin-top: -5px;
  }
  &_type {
    height: 19px;
    line-height: 19px;
    margin-top: 5px;
    padding: 0 5px;
    border-radius: 3px;
    background-color: var(--accent-color);
    font-size: 12px;
    font-weight: 500;
    color: var(--text-color);
    display: inline-block;
    flex-grow: 0;
    width: fit-content;
  }
  &_btns {
    display: flex;
    justify-content: space-around;
    width: 100%;
    margin-top: 9px;
    margin-bottom: 10px;
  }
  &_btn {
    width: 121px;
    .icon {
      margin-right: 5px;
      font-size: 13.3px;
    }
  }
}
</style>
